import { Component, OnInit, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  logoSrc: string = 'assets/qube-connect/icons/404-light.svg';
  constructor(private cd: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.setLogoBasedOnTheme();
    
    // Listen for system theme changes
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    darkModeQuery.addEventListener('change', () => {
      this.setLogoBasedOnTheme();
      this.cd.detectChanges();
    });
  }

  private setLogoBasedOnTheme(): void {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.logoSrc = isDarkMode 
      ? 'assets/qube-connect/icons/404-dark.svg'
      : 'assets/qube-connect/icons/404-light.svg';
  }

  closeWindow(){
    
  }
}